import { Component, OnInit, ViewChild, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import * as moment from 'moment';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { MatSort } from '@angular/material/sort';
import { StudentService } from '../../../shared-components/student/student.service';
import { YearService } from '../../../shared-components/year/year.service';
import { LoginService } from '../../../shared-modules/login/login.service';
import { AssignmentService } from '../assignment.service';
import { AssignmentsDTO } from '../assignment.model';
import { Subscription } from 'rxjs';
import { LoginSettings } from '../../../shared-modules/login/loginSetting.model';
import { Utility } from '../Utility';
import { UserService } from '../../../shared-components/user/user.service';
import { AssignmentFilterPipe } from '../assignment-filter.pipe';
import { Attachment } from '../../../shared-components/models/attachment.model';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { AssignmentFilterParam } from '../assignment-filter-param';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { Router } from '@angular/router';
import { SendEmailService } from '../../../shared-modules/send-email/send-email.service';
import { formatDate } from '@angular/common';

@Component({
    selector: 'upcoming-missing',
    templateUrl: './upcoming-missing.component.html',
    styleUrls: ['./upcoming-missing.component.css'],
    animations: [detailExpand],
})
export class UpcomingMissingComponent implements OnInit, OnDestroy {

    local_filterParam = new AssignmentFilterParam();

    @Input() shown: boolean;
    @Output() missingRetrieved = new EventEmitter();

    // ----------Angular Material------------------------------------
    angularMatData: TylerMatTableDataSource;
    @ViewChild(MatSort) set sort(value: MatSort) {
        if (this.angularMatData) {
            this.angularMatData.sort = value; {
                this.angularMatData.sortingDataAccessor = (item: AssignmentsDTO, property: string) => {
                    if (property == 'Assignment') {
                        return item.Assignment.toLowerCase();
                    }
                    else {
                        return this.angularMatData.defaultSortingAccessor(item, property);
                    }
                };
            }
        }
    }
    columnsToDisplay: string[] = ['More', 'Course', 'Term', 'DueDateDay', 'DueDate', 'AssignedDateDay', 'AssignedDate', 'Assignment', 'Category', 'Possible'];
    canSendEmail: boolean;
    public utilityClass = Utility;
    @Input() clearFilterEvent: EventEmitter<any>;

    subscriptions: Subscription[] = [];
    loginSettings: LoginSettings;
    studentAttachments: Attachment[] = [];
    studentLoaded = false;

    constructor(
        private studentService: StudentService,
        private yearService: YearService,
        private loginService: LoginService,
        private userService: UserService,
        private assignmentService: AssignmentService,
        private assignmentFilterPipe: AssignmentFilterPipe,
        private router: Router,
        private sendEmailService: SendEmailService

    ) {

        this.loginSettings = this.loginService.LoginSettings;

        if (!this.loginSettings.ParentPortalAssignmentsShowEffectiveScore) {
            this.columnsToDisplay = this.columnsToDisplay.filter(x => x !== 'EffectiveScores');
        }
        this.canSendEmail = (this.userService.userType == 2 || this.userService.userType === 3) ? this.loginSettings.AllowParentStudentEmail : true;

        this.subscriptions.push(studentService.selectedStudentStream$.subscribe(
            studentId => {
                this.assignmentService.studentAssignmentsUPMG = [];
                this.refresh(); 
            }));

        this.subscriptions.push(yearService.observableStudent360YearStream$.subscribe(
            student360Year => {
                this.assignmentService.studentAssignmentsUPMG = [];
                this.refresh();
            }));

        this.subscriptions.push(this.assignmentService.filterChange.subscribe(() => {
            if (!this.assignmentService.ShowByClass) {
                this.applyFilter();
            }
        }
        ));
    }

    ngOnInit() {
        if (this.clearFilterEvent) {
            this.subscriptions.push(
                this.clearFilterEvent.subscribe(() => {
                    if (this.shown) {
                        this.angularMatData.removeAllFilters();
                    }
                })
            );
        }
    }

    ngOnDestroy() {
        // POST: ends all subscriptions
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }


    refresh() {
        this.local_filterParam.FromDueDate = this.utilityClass.addDays(-30);
        this.local_filterParam.ToDueDate = this.utilityClass.addDays(30);

        if (!this.assignmentService.studentAssignmentsUPMG || this.assignmentService.studentAssignmentsUPMG.length === 0) {
            this.getStudentAssignmentUPMG();
            this.getStudentAttachments();
        }

    }

    loadFilterParam() {
        this.assignmentService.filterParam = this.local_filterParam;
        this.applyFilter();
    }

    getStudentAssignmentUPMG(): void {
        setTimeout(() => {
            this.assignmentService.getStudentAssignments(
                this.studentService.selectedStudent.Id,
                this.yearService.student360Year.Id,
                this.assignmentService.selectedSectionId,
                Utility.getDateString(this.local_filterParam.FromDueDate),
                Utility.getDateString(this.local_filterParam.ToDueDate),
                -1,
                this.studentService.studentEnrollment.SiteYearId
            ).subscribe(data => {
                this.angularMatData = new TylerMatTableDataSource();
                this.angularMatData.data = [];
                if (data.length > 0) {
                    this.assignmentService.studentAssignmentsUPMG = data.filter(x => x.ShowOnPortal === true && x.SystemGrade === false);
                    this.angularMatData.data = this.assignmentFilterPipe.transform(this.assignmentService.studentAssignmentsUPMG, this.local_filterParam, this.loginSettings.V10);
                    if (this.angularMatData.data.length > 0 && !this.studentLoaded && !this.assignmentService.preventTabSwitch) {
                        this.missingRetrieved.emit();
                        this.studentLoaded = true;
                    }
                    else {
                        this.assignmentService.preventTabSwitch = undefined;
                    }
                }
            });
        }, 0);
    }

    getStudentAttachments(): void {
        setTimeout(() => {
            this.assignmentService.getStudentAttachment(
                this.studentService.selectedStudent.Id,
                this.yearService.student360Year.Id,
                this.assignmentService.selectedSectionId,
                Utility.getDateString(this.local_filterParam.FromDueDate),
                Utility.getDateString(this.local_filterParam.ToDueDate),
                -1,
                this.studentService.studentEnrollment.SiteYearId
            ).subscribe(data => setTimeout(() => this.studentAttachments = data, 0));
        }, 0);
    }

    applyFilter() {
        if (this.assignmentService.filterParam) {
            Object.assign(this.local_filterParam, this.assignmentService.filterParam);
            this.angularMatData.data = this.assignmentFilterPipe.transform(this.assignmentService.studentAssignmentsUPMG, this.assignmentService.filterParam, this.loginSettings.V10);
        }
        else {
            this.angularMatData.data = this.assignmentService.studentAssignmentsUPMG;
        }
    }

    showToggleIcon(row: AssignmentsDTO): boolean {
        let toggle = true;

        if (this.loginSettings.V10) {
            toggle = (!!row.Comment) || (!!row.AttachmentDetail) || this.isAttachmentExists(row.AssignmentId) || (row.GradeBookObjectives ? row.GradeBookObjectives.length : 0) >= 0;
        }
        else { // v9
            toggle = this.canSendEmail || (!!row.Comment) || (!!row.Summary) || (!!row.AttachmentDetail) || this.isAttachmentExists(row.AssignmentId) || (row.GradeBookObjectives ? row.GradeBookObjectives.length : 0) >= 0;
        }

        return toggle;
    }

    isAttachmentExists(assignmentId: number): boolean {
        return this.studentAttachments.findIndex(x => x.AssignmentId === assignmentId) >= 0;
    }

    getStudentAttachmentByAssignmentId(assignmentId: number): Attachment[] {
        return this.studentAttachments.filter(x => x.AssignmentId === assignmentId);
    }

    getSBSScore(sbs: any) {
        return this.loginSettings.V10 ? sbs.V10Score : (sbs.Score == -1 ? '' : sbs.Score);
    }

    sendEmail(teacherName: string, teacherEmail: string) {
        this.sendEmailService.teacherName = teacherName;
        this.sendEmailService.teacherEmailAddress = teacherEmail;
        if (!this.userService.studentInformationView) {
            this.router.navigateByUrl('/student360/sendEmail');
        }
        else {
            this.userService.updateStudentViewRoute('/student360/sendEmail');
        }
    }

    getAssignmentStatus(status: number, dueDate: string) {
        switch (status) {
            case 1:
                return 'Today ';
            case 3:
                return 'Missing ';
            case 5:
                return 'Tomorrow ';
            default:
                return formatDate(dueDate, 'E', 'en-US');
        }
    }

    // --------- Toggle Row ----------------------------

    toggleExpanded(row: any) {
        this.angularMatData.toggleExpanded(row);
    }

    checkExpanded(row: any): boolean {
        return this.angularMatData.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        this.angularMatData.expandAll(expand);
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        this.angularMatData.rowKeyPress(event, row);
    }

    // ------------Aria/Accessibility---------------------------
    getAriaRow(row: AssignmentsDTO): string {
        const colList: string[] = ['Course', 'Grading Period', 'Due Date', 'Assigned Date', 'Assignment', 'Category'];

        const dataList: string[] = [
            row.Course,
            row.Term,
            moment(row.DueDate).format('MM/dd/yy'),
            moment(row.AssignedDate).format('MM/dd/yy'),
            row.AssignmentShortName,
            row.Category
        ];
        return AriaDirective.concatAriaStrings(colList, dataList);
    }

}
